import React from 'react';
import heroBanner from '../../assets/hero-section-banner.jpeg';

const HeroSection = () => {
  return (
    <section className="bg-navy py-8 md:py-12">
      <div className="container mx-auto px-4">
        <img
          src={heroBanner}
          alt="Healthcare Heroes, Re-Engineered. Designed for supreme comfort, durability, and style. Features 4-way stretch fabric, a soft drawstring waistband, reinforced stitching, and deep cargo pockets."
          className="w-full h-auto rounded-lg shadow-lg"
        />
      </div>
    </section>
  );
};

export default HeroSection;